export default __webpack_public_path__ + "bae0945625395b0b51e3e788e2daf2cb.png";